import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoZoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 99 48"
    {...props}
  >
    <g clipPath="url(#Logo_Zoom_svg__a)">
      <path
        fill="#2D8CFF"
        fillRule="evenodd"
        d="M80.322 20.597c.374.646.497 1.38.537 2.206l.053 1.1v7.698l.055 1.102c.108 1.799 1.435 3.13 3.249 3.243l1.096.054V23.904l.054-1.1c.045-.817.166-1.566.546-2.216a4.395 4.395 0 0 1 7.612.014c.374.645.49 1.394.535 2.201l.055 1.098v7.7l.054 1.102c.113 1.808 1.43 3.139 3.249 3.243l1.096.054V22.803a8.8 8.8 0 0 0-12.42-8.023 8.8 8.8 0 0 0-2.978 2.203 8.8 8.8 0 0 0-6.6-2.982 8.7 8.7 0 0 0-4.928 1.512c-.857-.956-2.774-1.512-3.875-1.512V36l1.1-.054c1.842-.122 3.172-1.416 3.244-3.243l.059-1.102v-7.697l.054-1.1c.046-.831.162-1.561.537-2.211a4.407 4.407 0 0 1 6.006-1.604 4.4 4.4 0 0 1 1.61 1.608M5.014 35.947l1.1.053h16.5l-.055-1.097c-.149-1.809-1.43-3.13-3.244-3.248l-1.1-.054H8.316l13.197-13.202-.054-1.096c-.086-1.827-1.42-3.147-3.244-3.248l-1.101-.05-16.5-.004.055 1.1c.145 1.792 1.444 3.141 3.243 3.245l1.102.055h9.898L1.716 31.6l.054 1.102c.108 1.813 1.417 3.126 3.244 3.243m58.38-18.726a10.997 10.997 0 0 1-7.78 18.777 11 11 0 0 1-7.78-3.22c-4.296-4.296-4.296-11.261 0-15.557a10.99 10.99 0 0 1 11.987-2.385 11 11 0 0 1 3.573 2.386m-3.113 3.115a6.603 6.603 0 0 1 0 9.335 6.603 6.603 0 0 1-9.334 0 6.603 6.603 0 0 1 0-9.335 6.603 6.603 0 0 1 9.334 0M32.521 14a11 11 0 0 1 7.773 3.222c4.297 4.295 4.297 11.261 0 15.556a11.007 11.007 0 0 1-15.56 0c-4.295-4.296-4.295-11.261 0-15.557A11 11 0 0 1 32.507 14zm4.66 6.334a6.603 6.603 0 0 1 0 9.336 6.603 6.603 0 0 1-9.334 0 6.603 6.603 0 0 1 0-9.335 6.603 6.603 0 0 1 9.334 0z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Logo_Zoom_svg__a">
        <path
          fill="#fff"
          d="M.615 0h98v48h-98z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoZoom;
